import axios from "axios";
import convertKeys from "convert-keys";
import qs from "qs";

import { pathRole } from "../utils/formatter";
import storage from "../utils/storage";

export const baseUrl = () => {
  const isDevelop = process.env.NODE_ENV === "development";

  return isDevelop ? `http://${window.location.hostname}:3001` : "";
};

export const baseApiUrl = () => {
  const isDevelop = process.env.NODE_ENV === "development";

  return isDevelop ? `http://${window.location.hostname}:3001/api` : "/api";
};

const checkStatusCode = res => {
  if (res.status >= 500) {
    // 予期せぬエラーを表示
    throw new Error(null);
  }

  return res;
};

const errorCheck = res => {
  if (res.systemError) {
    throw new Error(res.systemError);
  }

  return res;
};

const mergeParams = params => {
  const token = storage.getToken();

  return { ...params, token };
};

const api = {
  get(path, params = {}) {
    const base = baseApiUrl();
    const role = pathRole();
    const stringifyParams = qs.stringify(
      convertKeys.toSnake(mergeParams(params))
    );

    return axios
      .get(`${base}/${role}/${path}?${stringifyParams}`)
      .then(res => checkStatusCode(res))
      .then(res => convertKeys.toCamel(res.data))
      .then(res => errorCheck(res));
  },
  post(path, params = {}) {
    const base = baseApiUrl();
    const role = pathRole();

    return axios
      .post(`${base}/${role}/${path}`, convertKeys.toSnake(mergeParams(params)))
      .then(res => checkStatusCode(res))
      .then(res => convertKeys.toCamel(res.data))
      .then(res => errorCheck(res));
  },
  patch(path, params = {}) {
    const base = baseApiUrl();
    const role = pathRole();

    return axios
      .patch(
        `${base}/${role}/${path}`,
        convertKeys.toSnake(mergeParams(params))
      )
      .then(res => checkStatusCode(res))
      .then(res => convertKeys.toCamel(res.data))
      .then(res => errorCheck(res));
  },
  delete(path, params = {}) {
    const base = baseApiUrl();
    const role = pathRole();
    const snakedParams = convertKeys.toSnake(mergeParams(params));

    return axios
      .delete(`${base}/${role}/${path}`, { params: snakedParams })
      .then(res => checkStatusCode(res))
      .then(res => convertKeys.toCamel(res.data))
      .then(res => errorCheck(res));
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js